<script lang="ts">
    import { fade } from 'svelte/transition';

    import { TOAST_WARN_ICON } from './constants/loginImage';

    import webp from '@/actions/webp';

    type ToastType = 'default' | 'success' | 'error';

    export let defaultDuration = 3000;

    let message = '';
    let type: ToastType = 'default';
    let visible = false;
    let timer: ReturnType<typeof setTimeout> | null = null;

    interface ToastOptions {
        duration?: number;
        type?: ToastType;
    }

    export function show(content: string, options: ToastOptions = {}) {
        const { duration = defaultDuration, type: toastType = 'default' } = options;

        message = content;
        type = toastType;
        visible = true;

        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(() => {
            visible = false;
            timer = null;
        }, duration);
    }

    export function hide() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }

        visible = false;
    }
</script>

{#if visible}
    <div
        class="toast"
        role="status"
        aria-live="polite"
        transition:fade={{ duration: 150 }}
    >
        {#if type === 'error'}
            <div class="toast-icon" use:webp={TOAST_WARN_ICON}></div>
        {/if}
        <div class="toast-content">{message}</div>
    </div>
{/if}

<style lang="scss">
    .toast {
        position: fixed;
        box-sizing: border-box;
        left: 50%;
        top: 40%;
        transform: translate(-50%, -50%);
        max-width: 90vw;
        padding: 0.24rem 0.32rem;
        min-height: 1.2rem;
        border-radius: 0.4rem;
        background: #0c0c0d;
        color: #fff;
        font-family: DiDiSans-Pro-Medium;
        font-size: 0.28rem;
        line-height: 0.36rem;
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;

        .toast-content {
            flex: 1;
            min-width: 0;
            width: max-content;
        }

        .toast-icon {
            flex-shrink: 0;
            display: inline-block;
            width: 0.72rem;
            height: 0.72rem;
            background-size: 100% 100%;
            margin-right: 0.2rem;
        }
    }
</style>
